import { Check, CircleAlert, View } from "lucide-react";
import { useState, useEffect } from "react";
import { CustomProperty } from "winslow-core";
import { validateEmail } from "../../uiHelpers";
import { AppCustomPropertyError } from "./AppCustomPropertyError";
import { LongSettings } from "./customPropertyConfig";

type AppCustomPropertyLongProps = {
    customProperty: CustomProperty;
    data: any;
    disabled: boolean;
    validate: boolean;
    onChange: (label: string, data: any) => void;
}

export const AppCustomPropertyLong = ({customProperty, data, disabled, validate, onChange} : AppCustomPropertyLongProps) => {

    const [value, setValue] = useState<string>(data as string || "");

    const settings = JSON.parse(customProperty.settings || "{}") as LongSettings;

    useEffect(() => {
        if (data && data !== value) {
            setValue(data as string || "");
        }
    }, [data]);

    // useEffect(() => {
    //     onChange(customProperty.label, value);
    // }, [value]);

    return (
        <div className="app-custom-property-short">
            {/* <div className="app-custom-property-label">
                {customProperty.label}
            </div> */}
            <div className="app-custom-property-value">
               
                <textarea 
                    value={value}
                    disabled={disabled}
                    name={customProperty.label}
                    onChange={(event) => {
                        setValue(event.target.value);
                        onChange(customProperty.label, event.target.value);
                    }}
                    maxLength={settings?.maxCharsOn ? settings?.maxChars : undefined}
                />
                <AppCustomPropertyError 
                    flagRequired={validate && !value && customProperty.required}
                />
                {/* {validate && !value && customProperty.required &&
                    <div className="app-employee-record-error">
                        <Check size={16} color="red"/>
                    </div>
                } */}
            </div>
        </div>
    )
}
